export const teams = {
  "st-leonard": {
    slug: "st-leonard",
    name: "AS St-Léonard",
    founded: "1978",
    season: "2027",
    city: "Saint-Léonard, Montréal",
    logo: "/teams/st-leonard/logo.png",
    banner: "/teams/st-leonard/lions-2027-banner.webp",
    bannerPresentation: "campaign",
    accent: "#38BDF8",
    navy: "#14213D",
    sky: "#2E9BD6",
    colorwayEn: "Navy / Sky / White",
    colorwayFr: "Marine / Ciel / Blanc",
    sizeRangeEn: "Youth XS — Adult XXL",
    sizeRangeFr: "Junior XS — Adulte XXL",
    palette: ["#14213D", "#2E9BD6", "#FFFFFF"],
    matchKit: {
      image: "/teams/st-leonard/kit/match-kit-2027.png",
      title: "The 2027 Match Kit", titleFr: "La tenue de match 2027",
      description: "Croatia M098 in navy / sky, with the St-Léonard crest on the wearer's right chest. Paired with navy Vista P8000 shorts with tonal side stripes and navy UEFA C002 socks.",
      descriptionFr: "Croatia M098 marine / ciel, avec l'écusson de St-Léonard sur le côté droit de la poitrine. Agencé au short Vista P8000 marine à bandes latérales ton sur ton et aux chaussettes UEFA C002 marine.",
    },
    en: {
      tagline: "AS ST-LÉONARD · EST. 1978",
      collectionTitle: "2027 COLLECTION",
      lineup: "The Line-Up",
      categories: "MATCH · TRAINING · TRAVEL",
      suppliedBy: "SUPPLIED BY MASS / DM SPORTS",
      intro:
        "Every AS St-Léonard player is outfitted head-to-toe in Mass Sport Italian athletic wear this season — each piece finished in the club's navy and embroidered with the St-Léonard crest.",
    },
    fr: {
      tagline: "AS ST-LÉONARD · FONDÉ EN 1978",
      collectionTitle: "COLLECTION 2027",
      lineup: "L'Alignement",
      categories: "MATCH · ENTRAÎNEMENT · VOYAGE",
      suppliedBy: "FOURNI PAR MASS / DM SPORTS",
      intro:
        "Chaque joueur de l'AS St-Léonard est habillé de la tête aux pieds en vêtements sportifs italiens Mass Sport cette saison — chaque pièce en marine du club et brodée de l'écusson de St-Léonard.",
    },
    items: [
      {
        n: 11, code: "#M098", tag: "MATCH", tagFr: "MATCH",
        name: "Croatia M098 Jersey", nameFr: "Maillot Croatia M098",
        color: "Navy / Sky", colorFr: "Marine / Ciel",
        fabric: "100% POLYESTER", fabricFr: "100% POLYESTER",
        desc: "Short-sleeve match jersey with sky-blue checkered shoulders and collar, finished with the St-Léonard crest on the wearer's right chest.",
        descFr: "Maillot de match à manches courtes avec épaules à damier et col bleu ciel, orné de l'écusson de St-Léonard sur le côté droit de la poitrine.",
        image: "/teams/st-leonard/kit/croatia-navy-sky.png", crest: true,
      },
      {
        n: 8, code: "#P8000", tag: "MATCH", tagFr: "MATCH",
        name: "Vista P8000 Shorts", nameFr: "Short Vista P8000",
        color: "Navy / Navy", colorFr: "Marine / Marine",
        fabric: "BRUSHED POLYESTER", fabricFr: "POLYESTER BROSSÉ",
        desc: "Navy match shorts with tonal navy side stripes and an elasticated drawcord waist, paired with the Croatia jersey.",
        descFr: "Short de match marine à bandes latérales marine ton sur ton et taille élastiquée à cordon, agencé au maillot Croatia.",
        image: "/teams/st-leonard/kit/vista-navy-navy.png", crest: false,
      },
      {
        n: 9, code: "#C002", tag: "MATCH", tagFr: "MATCH",
        name: "UEFA C002 Socks", nameFr: "Chaussettes UEFA C002",
        color: "Navy", colorFr: "Marine",
        fabric: "COMPRESSION KNIT", fabricFr: "MAILLE COMPRESSION",
        desc: "Navy knee-high match socks with a ribbed cuff, cushioned footbed and woven Mass branding.",
        descFr: "Chaussettes de match hautes marine avec revers côtelé, semelle rembourrée et marque Mass tissée.",
        image: "/teams/st-leonard/kit/uefa-navy.png", crest: false,
      },
      {
        n: 1, code: "#7210-NW", tag: "TRAVEL", tagFr: "VOYAGE",
        name: "Porto Nylon Jacket", nameFr: "Veste Nylon Porto",
        color: "Navy / White", colorFr: "Marine / Blanc",
        fabric: "WOVEN RIPSTOP", fabricFr: "RIPSTOP TISSÉ",
        desc: "Wind-resistant woven jacket with reflective sleeve stripes and contrast zip piping.",
        descFr: "Veste tissée coupe-vent avec bandes réfléchissantes sur les manches et passepoil de fermeture contrastant.",
        image: "/teams/st-leonard/kit/porto.png", crest: true,
      },
      {
        n: 2, code: "#7150-NW", tag: "TRAVEL", tagFr: "VOYAGE",
        name: "Francia Full-Zip Jacket", nameFr: "Veste Zippée Francia",
        color: "Navy / White", colorFr: "Marine / Blanc",
        fabric: "TRICOT", fabricFr: "TRICOT",
        desc: "Full-zip track jacket with twin shoulder stripes — for matchday arrivals and the bench.",
        descFr: "Veste de survêtement à fermeture intégrale avec doubles bandes aux épaules — pour les arrivées et le banc.",
        image: "/teams/st-leonard/kit/francia.png", crest: true,
      },
      {
        n: 3, code: "#4020-NV", tag: "TRAINING", tagFr: "ENTRAÎNEMENT",
        name: "Venus Trackpants", nameFr: "Pantalon Venus",
        color: "Navy", colorFr: "Marine",
        fabric: "POLY TRICOT", fabricFr: "TRICOT POLY",
        desc: "Tapered training pant with zip cuffs and side seam piping in club sky blue.",
        descFr: "Pantalon d'entraînement fuselé avec bas zippés et passepoil bleu ciel du club.",
        image: "/products/venus/navy.png", crest: false,
      },
      {
        n: 4, code: "#B040-NV", tag: "ACCESSORIES", tagFr: "ACCESSOIRES",
        name: "Nap Sac Bag", nameFr: "Sac Nap",
        color: "Navy", colorFr: "Marine",
        fabric: "RIPSTOP NYLON", fabricFr: "NYLON RIPSTOP",
        desc: "Lightweight drawstring gym sack with reinforced corners and embroidered crest.",
        descFr: "Sac de sport léger à cordon avec coins renforcés et écusson brodé.",
        image: "/teams/st-leonard/kit/backpack.png", crest: true,
      },
      {
        n: 5, code: "#9040-NV", tag: "OUTERWEAR", tagFr: "MANTEAU",
        name: "Winter Coat — Model Everest", nameFr: "Manteau d'Hiver — Model Everest",
        color: "Navy", colorFr: "Marine",
        fabric: "QUILTED NYLON", fabricFr: "NYLON MATELASSÉ",
        desc: "Insulated hooded 3/4 coat for touchline staff and cold-weather sessions.",
        descFr: "Manteau 3/4 isolé à capuchon pour le personnel et les séances par temps froid.",
        image: "/teams/st-leonard/kit/everest.png", crest: true,
      },
      {
        n: 6, code: "#5010-NV", tag: "TRAINING", tagFr: "ENTRAÎNEMENT",
        name: "Polyester T-Shirt", nameFr: "T-Shirt Polyester",
        color: "Navy", colorFr: "Marine",
        fabric: "MICRO MESH", fabricFr: "MICRO MAILLE",
        desc: "Lightweight everyday training tee with breathable mesh knit and printed club crest.",
        descFr: "T-shirt d'entraînement léger avec maille respirante et écusson imprimé du club.",
        image: "/teams/st-leonard/kit/tshirt.png", crest: true,
      },
      {
        n: 7, code: "#8075-NW", tag: "CLUBWEAR", tagFr: "CLUB",
        name: "Team Polo", nameFr: "Polo d'Équipe",
        color: "Navy / White", colorFr: "Marine / Blanc",
        fabric: "POLY PIQUÉ", fabricFr: "PIQUÉ POLY",
        desc: "Tipped-collar club polo with tonal knit and embroidered crest — off-pitch essential.",
        descFr: "Polo de club à col contrastant, maille tonale et écusson brodé — l'essentiel hors terrain.",
        image: "/teams/st-leonard/kit/polo.png", crest: true,
      },
      {
        n: 10, code: "#CAP-NV", tag: "CLUBWEAR", tagFr: "CLUB",
        name: "Team Cap", nameFr: "Casquette d'Équipe",
        color: "Navy", colorFr: "Marine",
        fabric: "STRUCTURED TWILL", fabricFr: "SERGÉ STRUCTURÉ",
        desc: "Six-panel structured cap with an embroidered club crest and an adjustable strap back.",
        descFr: "Casquette structurée six panneaux avec écusson du club brodé et fermeture ajustable à l'arrière.",
        image: "/teams/st-leonard/kit/cap.png", crest: false,
      },
    ],
  },

  "ahuntsic": {
    slug: "ahuntsic",
    name: "Braves d'Ahuntsic",
    founded: null,
    season: "2027",
    city: "Ahuntsic, Montréal",
    logo: "/teams/ahuntsic/logo.png",
    banner: null,
    accent: "#5B7BD0",
    navy: "#14213D",
    sky: "#2B4C9B",
    colorwayEn: "Navy / Royal / Red",
    colorwayFr: "Marine / Royal / Rouge",
    sizeRangeEn: "Youth XS — Adult XXL",
    sizeRangeFr: "Junior XS — Adulte XXL",
    palette: ["#14213D", "#2B4C9B", "#C1121C"],
    en: {
      tagline: "BRAVES D'AHUNTSIC · MONTRÉAL",
      collectionTitle: "2027 COLLECTION",
      lineup: "The Line-Up",
      categories: "MATCH · TRAINING · TRAVEL",
      suppliedBy: "SUPPLIED BY MASS / DM SPORTS",
      intro:
        "The Braves d'Ahuntsic squad steps out in Mass Sport Italian athletic wear this season — each piece finished in club navy and crested with the Braves d'Ahuntsic shield.",
    },
    fr: {
      tagline: "BRAVES D'AHUNTSIC · MONTRÉAL",
      collectionTitle: "COLLECTION 2027",
      lineup: "L'Alignement",
      categories: "MATCH · ENTRAÎNEMENT · VOYAGE",
      suppliedBy: "FOURNI PAR MASS / DM SPORTS",
      intro:
        "L'équipe des Braves d'Ahuntsic est habillée en vêtements sportifs italiens Mass Sport cette saison — chaque pièce en marine du club et ornée de l'écusson des Braves d'Ahuntsic.",
    },
    items: [
      {
        n: 1, code: "#7150-NW", tag: "TRAVEL", tagFr: "VOYAGE",
        name: "Full-Zip Jacket", nameFr: "Veste Zippée",
        color: "Navy / White", colorFr: "Marine / Blanc",
        fabric: "WOVEN RIPSTOP", fabricFr: "RIPSTOP TISSÉ",
        desc: "Wind-resistant full-zip jacket with reflective sleeve stripes and stand collar.",
        descFr: "Veste zippée coupe-vent avec bandes réfléchissantes aux manches et col montant.",
        image: "/teams/ahuntsic/kit/francia.png", crest: true,
      },
      {
        n: 2, code: "#8075-NW", tag: "CLUBWEAR", tagFr: "CLUB",
        name: "Team Polo", nameFr: "Polo d'Équipe",
        color: "Navy / White", colorFr: "Marine / Blanc",
        fabric: "POLY PIQUÉ", fabricFr: "PIQUÉ POLY",
        desc: "Tipped-collar club polo with tonal knit and embroidered crest — off-pitch essential.",
        descFr: "Polo de club à col contrastant, maille tonale et écusson brodé — l'essentiel hors terrain.",
        image: "/teams/ahuntsic/kit/polo.png", crest: true,
      },
      {
        n: 3, code: "#T109-NV", tag: "TRAINING", tagFr: "ENTRAÎNEMENT",
        name: "Neptune T109 Top", nameFr: "Haut Neptune T109",
        color: "Navy", colorFr: "Marine",
        fabric: "100% POLYESTER", fabricFr: "100% POLYESTER",
        desc: "Quarter-zip training top finished with the club crest and mass wordmark.",
        descFr: "Haut d'entraînement quart-zip orné de l'écusson du club et du logo mass.",
        image: "/teams/ahuntsic/kit/neptune-top.png", crest: true,
      },
      {
        n: 9, code: "#T116-NV", tag: "TRAINING", tagFr: "ENTRAÎNEMENT",
        name: "Venus T116 Trackpants", nameFr: "Pantalon Venus T116",
        color: "Navy", colorFr: "Marine",
        fabric: "100% POLYESTER", fabricFr: "100% POLYESTER",
        desc: "Tapered training pant with zip ankle cuffs and the mass wordmark.",
        descFr: "Pantalon d'entraînement fuselé avec bas zippés et logo mass.",
        image: "/teams/ahuntsic/kit/venus.png", crest: false,
      },
      {
        n: 4, code: "#B040-NV", tag: "ACCESSORIES", tagFr: "ACCESSOIRES",
        name: "Nap Sac Bag", nameFr: "Sac Nap",
        color: "Navy", colorFr: "Marine",
        fabric: "RIPSTOP NYLON", fabricFr: "NYLON RIPSTOP",
        desc: "Lightweight backpack with reflective side stripes, mesh pocket and embroidered crest.",
        descFr: "Sac à dos léger avec bandes réfléchissantes, poche en filet et écusson brodé.",
        image: "/teams/ahuntsic/kit/backpack.png", crest: true,
      },
      {
        n: 5, code: "#18500", tag: "CLUBWEAR", tagFr: "CLUB",
        name: "Team Hoodie", nameFr: "Kangourou d'Équipe",
        color: "Red / Royal / Black / Navy", colorFr: "Rouge / Royal / Noir / Marine",
        fabric: "HEAVY BLEND FLEECE", fabricFr: "MOLLETON HEAVY BLEND",
        desc: "Heavy Blend pullover hoodie with a double-lined hood, pouch pocket and embroidered club crest — offered in four club colours.",
        descFr: "Kangourou Heavy Blend à capuche double épaisseur, poche kangourou et écusson brodé du club — offert en quatre couleurs du club.",
        image: "/teams/ahuntsic/kit/all-hoodies.webp", crest: true,
      },
      {
        n: 6, code: "#6400", tag: "CLUBWEAR", tagFr: "CLUB",
        name: "Cotton T-Shirt", nameFr: "T-Shirt Coton",
        color: "Navy / Royal / Red / Black", colorFr: "Marine / Royal / Rouge / Noir",
        fabric: "100% COTTON", fabricFr: "100% COTON",
        desc: "Soft ring-spun cotton crew tee with the embroidered club crest on the left chest — offered in four club colours.",
        descFr: "T-shirt col rond en coton filé à l'anneau avec écusson brodé du club côté cœur — offert en quatre couleurs du club.",
        image: "/teams/ahuntsic/kit/tshirts.png", crest: true,
      },
      {
        n: 7, code: "#M048", tag: "TRAINING", tagFr: "ENTRAÎNEMENT",
        name: "Armor Base Layer", nameFr: "Sous-couche Armor",
        color: "Navy / Royal / White", colorFr: "Marine / Royal / Blanc",
        fabric: "POLY-ELASTANE", fabricFr: "POLY-ÉLASTHANNE",
        desc: "Long-sleeve compression base layer worn under the kit for support and moisture control — offered in three club colours.",
        descFr: "Sous-couche de compression à manches longues portée sous le kit pour le soutien et le contrôle de l'humidité — offerte en trois couleurs du club.",
        image: "/teams/ahuntsic/kit/all-armors.webp", crest: false,
      },
      {
        n: 8, code: "#C100-NV", tag: "ACCESSORIES", tagFr: "ACCESSOIRES",
        name: "Team Cap", nameFr: "Casquette d'Équipe",
        color: "Navy", colorFr: "Marine",
        fabric: "COTTON TWILL", fabricFr: "SERGÉ DE COTON",
        desc: "Structured six-panel cap with the embroidered club crest on the front panel.",
        descFr: "Casquette structurée six panneaux avec écusson brodé du club sur le panneau avant.",
        image: "/teams/ahuntsic/kit/cap.png", crest: true,
      },
      {
        n: 10, code: "#T200-NV", tag: "ACCESSORIES", tagFr: "ACCESSOIRES",
        name: "Winter Tuque", nameFr: "Tuque d'Hiver",
        color: "Navy", colorFr: "Marine",
        fabric: "RIBBED KNIT", fabricFr: "TRICOT CÔTELÉ",
        desc: "Ribbed knit winter tuque with a folded cuff and the embroidered club crest on the front.",
        descFr: "Tuque d'hiver en tricot côtelé avec revers et écusson brodé du club à l'avant.",
        image: "/teams/ahuntsic/kit/tuque.png", crest: true,
      },
    ],
  },
};

export const teamList = Object.values(teams);
